import envName from './lib/env';
export * from './lib/app/config.app';
export * from './lib/api/config.api';

export { envName };
